import React, { useEffect } from 'react'
import { SplitScreenContext } from '../../layouts/SplitScreenLayout'

export const childSafetyContext: SplitScreenContext = {
  id: 'child-safety',
  title: 'Child Safety',
  message: '',
  contentSide: 'left',
}

const ChildSafetyPage = () => {
  useEffect(() => {}, [])

  return (
    <div>
      Our app <b>is not directed to children</b> and is intended{' '}
      <b>only for users age 18 and older</b>. We require users to confirm their date of birth during
      account creation, and access is restricted to adults.
      <br />
      <br />
      We do not collect, target, or display content to children, and we do not knowingly allow
      minors to use the app.
      <br />
      <br />
      Users may report any concerns about child safety or inappropriate content by contacting us at{' '}
      <a className="simple-link" href="mailto:support@ivyapp.com">
        support@ivyapp.com
      </a>{' '}
      or by reporting any issues using the Feedback mechanism within the app.
      <br />
      <br />
      We are committed to protecting user safety and privacy, and our content, features, and
      marketing are designed solely for an adult audience.
    </div>
  )
}

export default ChildSafetyPage
